import { styled } from "@mui/material/styles";
import { Box, Stack, AppBar, Toolbar } from "@mui/material";
import { HEADER, NAVBAR } from "../../../config";
import Searchbar from "./Searchbar";
import AccountPopover from "./AccountPopover";
import useOffSetTop from "../../../_helpers/hooks/useOffSetTop";
import useResponsive from "../../../_helpers/hooks/useResponsive";
import { IconButtonAnimate } from "../../../_components/animate";
import Logo from "../../../_components/Logo";
import Iconify from "../../../_components/Iconify";
import cssStyles from "../../../_helpers/utils/cssStyles";
import CollapseButton from "../navbar/CollapseButton";
import useCollapseDrawer from "../../../_helpers/hooks/useCollapseDrawer";

interface RootStyleProps {
  isCollapse?: boolean | any;
  isOffset?: boolean;
  verticalLayout?: boolean;
  theme?: any;
}

interface DashboardHeaderProps {
  onOpenSidebar?: any;
  isCollapse?: boolean | any;
  verticalLayout?: boolean;
}

const RootStyle: any = styled(AppBar, {
  shouldForwardProp: (prop: any) =>
    prop !== "isCollapse" && prop !== "isOffset" && prop !== "verticalLayout",
})(({ isCollapse, isOffset, verticalLayout, theme }: RootStyleProps) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: theme.customShadows.z1,
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(["width", "height"], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up("lg")]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: "100%",
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

export default function DashboardHeader({
  onOpenSidebar,
  isCollapse = false,
  verticalLayout = false,
}: DashboardHeaderProps) {
  const isOffset =
    useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  // const {
  //   // isCollapse,
  //   collapseClick,
  //   collapseHover,
  //   onToggleCollapse,
  //   onHoverEnter,
  //   onHoverLeave,
  // } = useCollapseDrawer();

  const isDesktop = useResponsive("up", "lg");

  return (
    <RootStyle
      isCollapse={isCollapse}
      isOffset={isOffset}
      verticalLayout={verticalLayout}
    >
      <Toolbar
        sx={{
          minHeight: "100% !important",
          px: { lg: 5 },
        }}
      >
        {/* {isDesktop && (
          // <Stack direction="row" alignItems="center" justifyContent="flex-end">
          <CollapseButton
            onToggleCollapse={onToggleCollapse}
            collapseClick={collapseClick}
            isCollapse={isCollapse}
          />
          // </Stack>
        )} */}
        {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}

        {!isDesktop && (
          <IconButtonAnimate
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary" }}
          >
            <Iconify icon={"AcUnitOutlined"} />
          </IconButtonAnimate>
        )}

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 0.5, sm: 1.5 }}
        >
          {/* <LanguagePopover /> */}
          {/* <NotificationsPopover /> */}
          {/* <ContactsPopover /> */}
          <AccountPopover />
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}
